let projectFilters = document.querySelectorAll('[data-project-filter]');
let projectItemSelector = '.cardList-item--project';

projectFilters.forEach((filter) => {
    filter.addEventListener('change',
        (event) => {
            const trigger = event.target;
            const filterParameter = trigger.dataset['projectFilter'].toLowerCase();
            let projectStyleElement = document.querySelector(`#project-filter-styles-${filterParameter}`);

            if (!projectStyleElement) {
                projectStyleElement = document.createElement('style');
                projectStyleElement.setAttribute('id', 'project-filter-styles-'+filterParameter);
                document.head.appendChild(projectStyleElement);
            }

            let isCheckBox = trigger.type === 'checkbox';
            let valueStatement = isCheckBox ? '' : `="${trigger.value}"`;

            if ((isCheckBox && trigger.checked) || !isCheckBox && trigger.value) {
                projectStyleElement.textContent = `${projectItemSelector}:not([data-${filterParameter}${valueStatement}]) { display: none }`;
            } else {
                projectStyleElement.textContent = '';
            }
        });
});